import React, { useEffect } from 'react'
import {
  ModalOverlay,
  ModalWrapper,
  ModalContent,
  CloseButton,
  Title,
  Description
} from './styles'

const ModalReviewFeedback = ({ isOpen, onClose, title, message }) => {
  useEffect(() => {
    if (isOpen) {
      const timeout = setTimeout(() => {
        onClose()
      }, 5000)

      return () => clearTimeout(timeout)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <ModalOverlay>
      <ModalWrapper>
        <CloseButton onClick={onClose} />
        <ModalContent>
          <Title>{title}</Title>
          <Description>{message}</Description>
        </ModalContent>
      </ModalWrapper>
    </ModalOverlay>
  )
}

export default ModalReviewFeedback
